












import {
  defineComponent,
} from '@vue/composition-api'
import PageSection from '@/components/layouts/PageSection.vue'
import ParticipantsList from './pods/ParticipantsList.vue'

export default defineComponent({
  components: {
    PageSection,
    ParticipantsList,
  },

  props: {
    studyId: { type: String, default: '' },
  },

})

